export interface ApiConfiguration {
  apiUrl: string;
}
// Config object to be passed to Msal on creation
export const apiConfig: ApiConfiguration = {
  apiUrl: process.env.REACT_APP_VA_API_URL
    ? process.env.REACT_APP_VA_API_URL
    : "http://localhost:7071/api",
};
